module.exports = __webpack_public_path__ + "static/media/endgun_false.2dfe6c6f.svg";